<div class="not-found vd-hero-bg">
  <div class="auroras" aria-hidden="true">
    <span class="aurora a1"></span>
    <span class="aurora a2"></span>
  </div>

  <div class="card vd-glass-strong vd-scale-in">
    <div class="logo-orbit">
      <span class="orbit"></span>
      <app-brand-logo size="xl" [animated]="true"></app-brand-logo>
    </div>

    <div class="error-code">
      <span class="d4">4</span>
      <span class="d0">0</span>
      <span class="d4">4</span>
    </div>

    <h1>Page introuvable</h1>
    <p>
      La page que vous cherchez s'est perdue dans le caddy.
      Pas d'inquiétude, on vous ramène à bon port.
    </p>

    <div class="actions">
      <vd-button variant="primary" size="lg" (click)="goHome()">
        <span class="material-icons-outlined">home</span>
        Aller à l'accueil
      </vd-button>
      <vd-button variant="secondary" size="lg" (click)="goBack()">
        <span class="material-icons-outlined">arrow_back</span>
        Page précédente
      </vd-button>
    </div>

    <a class="cache-link" href="/force-reload.html?auto=true">
      <span class="material-icons-outlined">refresh</span>
      Vider le cache si le problème persiste
    </a>
  </div>
</div>
